"use strict";

(function () {
  function Ajaxinate(options) {
    var defaults = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null
    };

    this.settings = Object.assign({}, defaults, options || {});

    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.destroy = this.destroy.bind(this);

    this.containerElement = null;
    this.paginationElement = null;

    this.initialize();
  }

  Ajaxinate.prototype.initialize = function () {
    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);

    if (!this.containerElement || !this.paginationElement) {
      return;
    }

    var methods = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };

    var initMethod = methods[this.settings.method] || this.addScrollListeners;
    initMethod.call(this);
  };

  Ajaxinate.prototype.addScrollListeners = function () {
    if (!this.paginationElement) return;

    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
  };

  Ajaxinate.prototype.addClickListener = function () {
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }
  };

  Ajaxinate.prototype.stopMultipleClicks = function (event) {
    event.preventDefault();

    if (!this.clickActive) return;

    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  };

  Ajaxinate.prototype.checkIfPaginationInView = function () {
    if (!this.paginationElement) return;

    var rect = this.paginationElement.getBoundingClientRect();
    var top = rect.top - this.settings.offset;
    var bottom = rect.bottom + this.settings.offset;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.removeScrollListener();

      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  };

  Ajaxinate.prototype.loadMore = function () {
    var self = this;

    this.request = new XMLHttpRequest();

    this.request.onreadystatechange = function () {
      if (self.request.readyState !== 4) return;

      if (self.request.status >= 200 && self.request.status < 300) {
        var responseDocument = self.request.responseXML;

        if (!responseDocument || !responseDocument.querySelector) {
          try {
            responseDocument = new DOMParser().parseFromString(
              self.request.responseText,
              "text/html"
            );
          } catch (error) {
            responseDocument = null;
          }
        }

        if (!responseDocument) {
          self.destroy();
          return;
        }

        var container = responseDocument.querySelector(self.settings.container);
        var pagination = responseDocument.querySelector(self.settings.pagination);

        if (container) {
          self.containerElement.insertAdjacentHTML("beforeend", container.innerHTML);
        }

        if (pagination) {
          self.paginationElement.innerHTML = pagination.innerHTML;
        } else {
          self.destroy();
        }

        if (!self.paginationElement.querySelector("a")) {
          self.destroy();
        }

        if (typeof self.settings.callback === "function") {
          self.settings.callback(responseDocument);
        }

        if (typeof window.CustomEvent === "function") {
          window.dispatchEvent(new CustomEvent("ajaxinate:complete"));
        } else if (document.createEvent) {
          var event = document.createEvent("Event");
          event.initEvent("ajaxinate:complete", true, true);
          window.dispatchEvent(event);
        }
        if (self.paginationElement.querySelector("a")) {
          self.initialize();
          self.clickActive = true;
        }
      } else {
        self.destroy();
      }
    };

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  };

  Ajaxinate.prototype.removeClickListener = function () {
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
    }
  };

  Ajaxinate.prototype.removeScrollListener = function () {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener("orientationchange", this.checkIfPaginationInView);
  };

  Ajaxinate.prototype.destroy = function () {
    var methods = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener
    };

    var destroyMethod = methods[this.settings.method] || this.removeScrollListener;
    destroyMethod.call(this);
  };

  window.Ajaxinate = Ajaxinate;
})();
